export enum GoogleAnalyticsEvent {
  BATLoadVertical = 'BAT_Load_Vertical',
  BATLoadHorizontal = 'BAT_Load_Horizontal',
  BATLoadByLeg = 'BAT_Load_By_Leg',
  BATViewChangedVertical = 'BAT_View_Changed_Vertical',
  BATViewChangedHorizontal = 'BAT_View_Changed_Horizontal',
  BATViewChangedByLeg = 'BAT_View_Changed_By_Leg'
}
